<template>
  <el-dialog
    title="处理"
    :lock-scroll="false"
    :show-close="false"
    :visible="oneComplainMessage.dialogFormVisibleHandler"
    width="500px"
  >
    <el-form class="fl" ref="contentForm" label-position="right" id="form" >
      <el-form-item label="回复内容" prop="content">
        <el-col :span="18">
          <el-input type="textarea" v-model="content"></el-input>
        </el-col>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="btnClickTrue">确 定</el-button>
      <el-button @click="btnClickCancle">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { complainReply } from "@/api/url";
import { mapState } from "vuex";
export default {
  props: {
    oneComplainMessage: Object,
  },
  data() {
    return {
    content: "",
    };
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
    }),
  },
  methods: {
    btnClickTrue() {
      const { id } = this.oneComplainMessage;
      this.$putRequest(complainReply(), {
        id,
        reply: this.content,
      }).then((data) => {
        if (data.status === 200) {
          this.$notify({
            type: "success",
            title: "成功",
            message: "处理成功！",
          });
          this.resetForm();
          this.oneComplainMessage.dialogFormVisibleHandler = false;
          this.$emit("func", this.curIndex);
        } else {
          this.$notify({
            type: "error",
            title: "失败",
            message: "处理失败！",
          });
        }
      });
    },
    btnClickCancle() {
      this.resetForm();
      this.oneComplainMessage.dialogFormVisibleHandler = false;
    },
    resetForm() {
      this.content='';
    },
  },
};
</script>
<style>
</style>